import React, { createContext, useState, useContext } from 'react';

const LeadContext = createContext();

export const useLeads = () => useContext(LeadContext);

export const LeadProvider = ({ children }) => {
  const [leads, setLeads] = useState([
    {
      id: 1,
      name: 'Sarah Jenkins',
      business: 'Jenkins Dental Care',
      email: 'sarah@example.com',
      phone: '555-0192',
      website: 'jenkinsdental.com',
      locations: '1',
      date: new Date().toISOString().split('T')[0]
    }
  ]);

  const addLead = (lead) => {
    setLeads([{ ...lead, id: Date.now(), date: new Date().toISOString().split('T')[0] }, ...leads]);
  };

  return (
    <LeadContext.Provider value={{ leads, addLead }}>
      {children}
    </LeadContext.Provider>
  );
};